/*
 * RTL Patch — Runs after vendor.js, before theme.js
 * Patches Flickity to inject rightToLeft: true for RTL locales
 */
(function() {
  'use strict';

  window.theme = window.theme || {};
  window.theme.isRTL = true;

  var OrigFlickity = window.theme.Flickity;
  if (!OrigFlickity) return;

  function PatchedFlickity(element, options) {
    options = options || {};
    if (typeof options.rightToLeft === 'undefined') {
      options.rightToLeft = true;
    }
    if (options.cellAlign === 'left') {
      options.cellAlign = 'right';
    }
    return new OrigFlickity(element, options);
  }

  PatchedFlickity.data = function(element) {
    return OrigFlickity.data(element);
  };

  PatchedFlickity.prototype = OrigFlickity.prototype;

  var descriptors = Object.getOwnPropertyDescriptors(OrigFlickity);
  Object.keys(descriptors).forEach(function(key) {
    if (key !== 'prototype' && !(key in PatchedFlickity)) {
      Object.defineProperty(PatchedFlickity, key, descriptors[key]);
    }
  });

  window.theme.Flickity = PatchedFlickity;
})();
